import { Icon } from '@iconify/react';
import React from 'react';
import { Link } from 'react-router-dom';

export default function SocialWidget() {
  return (
    <div className="cs_social_links_wrap flex justify-start items-center">
      <h2>Follow Us</h2>
      <div className="flex justify-start items-center gap-0">
        <Link target='_blank' rel='noreferrer' className='h-[60px] w-[60px]' to="https://www.instagram.com/noohraservices?igsh=MTh5dW9neHZpeDMwNA==">
          <Icon className='hover:text-red-800' width={30} icon="fa-brands:instagram" />
        </Link>
        <Link target='_blank' rel='noreferrer' className='h-[60px] w-[60px]' to="https://www.tiktok.com/@noohraservices?_t=ZM-8tdIb55Z3PJ&_r=1">
          <Icon className='hover:text-red-800' width={30} icon="fa-brands:tiktok" />
        </Link>
        <Link target='_blank' rel='noreferrer' className='h-[60px] w-[60px]' to="https://youtube.com/@noohralife?si=EradZ0feG2UPqDCj">
          <Icon className='hover:text-red-800' width={30} icon="fa-brands:youtube" />
        </Link>
        <Link target='_blank' rel='noreferrer' className='h-[60px] w-[60px]' to="https://www.linkedin.com/company/noohra-services/">
          <Icon className='hover:text-red-800' width={30} icon="fa-brands:linkedin-in" />
        </Link>
        <Link target='_blank' rel='noreferrer' className='h-[60px] w-[60px]' to="https://x.com/NoohraNigeria?t=DFjWSwph_duuA4JP879dZA&s=09">
          <Icon className='hover:text-red-800' width={30} icon="fa-brands:twitter" />
        </Link>
      </div>
    </div>
  );
}
